import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/cause_categories')({
  staticData: {
    permissionSection: 'settings',
    section: 'Settings',
    breadcrumb: 'Cause Categories',
  },
  component: () => <Outlet />,
});
